function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "prefix__b",
  width: "129.4%",
  height: "129.4%",
  x: "-14.7%",
  y: "-11.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329163024 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "prefix__a",
  cx: 34,
  cy: 34,
  r: 34
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#prefix__b)",
  xlinkHref: "#prefix__a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#prefix__a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#prefix__c)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#3E48A6",
  strokeWidth: 1.5,
  d: "M10.31 2.654c-.07-.187-.104-.385-.104-.586 0-.96.798-1.74 1.78-1.74.736 0 1.406.453 1.675 1.146l2.2 6.435H12.38c-.097 0-.171.004-.245.007h-.024l-1.8-5.262zm8.34 1.127c.086-.183.207-.346.351-.487.347-.34.802-.51 1.258-.51.456 0 .912.17 1.258.51.522.51.666 1.29.355 1.968l-1.387 2.72c-.436-.047-.884-.073-1.332-.073h-2.61l2.108-4.128z",
  transform: "translate(18.725 7.884)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#46BFB1",
  stroke: "#46BFB1",
  strokeWidth: 1.5,
  d: "M22.183 5.377c.359-.777.187-1.706-.432-2.312-.826-.803-2.162-.803-2.987 0-.172.168-.312.362-.425.59l-2.146 2.997-2.232-5.315C13.653.537 12.858 0 11.986 0 10.82 0 9.874.925 9.874 2.064c0 .24.043.472.129.712L11.76 7.92C5.22 8.236 0 13.537 0 20.01v23.932c0 2.898 2.411 5.255 5.375 5.255H26.16c2.965 0 5.376-2.357 5.376-5.255V20.01c0-6.115-4.667-11.184-10.704-11.987l1.351-2.646z",
  transform: "translate(18.725 7.884)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.65 3.781c.086-.183.207-.346.351-.487.347-.34.802-.51 1.258-.51.456 0 .912.17 1.258.51.522.51.666 1.29.355 1.968l-1.387 2.72c-.436-.047-.884-.073-1.332-.073h-2.61l2.108-4.128zM10.31 2.654c-.07-.187-.104-.385-.104-.586 0-.96.798-1.74 1.78-1.74.736 0 1.406.453 1.675 1.146l2.2 6.435H12.38c-.097 0-.171.004-.245.007h-.024l-1.8-5.262z",
  transform: "translate(18.725 7.884)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E48A6",
  stroke: "#3E48A6",
  strokeWidth: 0.7,
  d: "M24.37 26.543l-.034-.02-2.953-1.664c-.033-.019-.07-.029-.109-.029-.042 0-.083.012-.119.035-.069.044-.111.123-.11.207l.174 12.7v.04H10.317v-.04l.175-12.7c0-.084-.042-.164-.111-.207-.036-.023-.077-.035-.119-.035-.038 0-.075.01-.109.03l-2.952 1.663-.035.02-.017-.037-1.672-3.562-.016-.034.032-.018 4.655-2.5 1.896-1.018.014-.007.015.005.292.101.613.213c.895.31 1.834.468 2.79.468s1.895-.158 2.79-.468l.568-.197.338-.117.015-.005.014.007 1.832.985 4.718 2.533.033.018-.016.034-1.673 3.562-.017.037z",
  transform: "translate(18.725 7.884)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#46BFB1",
  strokeWidth: 0.7,
  d: "M24.677 26.975l1.909-4.066c.054-.115.009-.257-.1-.316l-6.883-3.696c-.032-.017-.069-.026-.105-.026-.025 0-.05.004-.073.012l-.223.078-.689.238-.1.035c-.849.294-1.739.444-2.645.444-.906 0-1.796-.15-2.645-.444l-.145-.05-.688-.24-.18-.061c-.023-.008-.047-.012-.072-.012-.036 0-.072.009-.104.026L5.05 22.593c-.11.06-.155.2-.1.316l1.909 4.066c.027.058.077.103.136.122.022.008.046.012.07.012.038 0 .075-.01.109-.03l2.797-1.576.056-.031-.001.066-.171 12.51c-.001.064.022.124.066.17.042.045.102.07.163.07h11.366c.062 0 .121-.025.163-.07.044-.046.067-.106.067-.17l-.171-12.51-.001-.066.056.031 2.796 1.577c.034.019.072.029.11.029.023 0 .047-.004.07-.012.059-.02.108-.064.136-.122z",
  transform: "translate(18.725 7.884)"
}))));

function SvgItemsInBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsInBag);
export default __webpack_public_path__ + "static/media/itemsInBag.c63a7d83.svg";
export { ForwardRef as ReactComponent };